import { Component } from '@angular/core';
import { ApplicationVersionService } from '@core';
import { useCheckVersion } from '@eliboo/shared/hooks';
import { getEnv } from '@env';
@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
  providers: [ApplicationVersionService],
  standalone: false,
})
export class AppComponent {
  constructor() {
    useCheckVersion('我的引立播', getEnv().versionCode, getEnv().baseUrl).checkVersion();
  }
}
